import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DataListParentCallLogProcess } from "src/app/shared/models/data-list";
import {
  DisputeCaseBaseDto,
} from "src/app/shared/models/dispute-resolution/dispute-base-models";
import { DataListService } from "src/app/shared/services/data-list.service";
import { AddEditCallLogComponent } from "../add-edit-call-log/add-edit-call-log.component";
import { CreateUpdateParentEngagementCallLogDto, ParentEngagementCallLogDto } from "src/app/shared/models/dispute-resolution/parent-engagement-models";
import { Subscription } from "rxjs";

@Component({
  selector: "app-call-logs-list",
  templateUrl: "./call-logs-list.component.html",
  styleUrls: ["./call-logs-list.component.scss"],
  standalone: false,
})
export class CallLogsListComponent implements OnInit, OnDestroy {
  @Input() disputeCase: DisputeCaseBaseDto;
  @Input() callLogs: CreateUpdateParentEngagementCallLogDto[] = [];
  @Output() callLogsChange = new EventEmitter<
    CreateUpdateParentEngagementCallLogDto[]
  >();

  displayedColumns: string[] = ["dataOfContact", "name", "process", "actions"];

  processOptions: DataListParentCallLogProcess[] = [];

  private subscriptions = new Subscription();

  constructor(
    private dataListService: DataListService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.dataListService
        .getParentCallLogProcesses({
          pageIndex: 0,
          pageSize: 100,
        })
        .subscribe((processOptions) => {
          this.processOptions = processOptions;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  addCallLog() {
    const dialogRef = this.dialog.open(AddEditCallLogComponent, {
      width: "1100px",
      data: {
        disputeCase: this.disputeCase,
        callLog: null,
        processOptions: this.processOptions,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.callLogs = [...this.callLogs, { ...result }];
        this.callLogsChange.emit(this.callLogs);
      }
    });
  }

  editCallLog(callLog: ParentEngagementCallLogDto) {
    const dialogRef = this.dialog.open(AddEditCallLogComponent, {
      width: "1100px",
      data: {
        disputeCase: this.disputeCase,
        callLog: { ...callLog },
        processOptions: this.processOptions,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (!result.id) {
          // Editing a newly created party (no id): match by reference
          const idx = this.callLogs.indexOf(callLog);
          if (idx !== -1) {
            this.callLogs = this.callLogs.map((p, i) =>
              i === idx ? { ...p, ...result } : p
            );
          }
        } else {
          // Editing an existing party (with id): match by id
          this.callLogs = this.callLogs.map((p) =>
            p.id && result.id && p.id === result.id ? { ...p, ...result } : p
          );
        }
        this.callLogsChange.emit(this.callLogs);
      }
    });
  }
}
